import anObject$1 from './an-object.js';
import aConstructor$1 from './a-constructor.js';
import wellKnownSymbol$1 from './well-known-symbol.js';

var anObject = anObject$1;
var aConstructor = aConstructor$1;
var wellKnownSymbol = wellKnownSymbol$1;
var SPECIES = wellKnownSymbol('species'); // `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor

var speciesConstructor = function (O, defaultConstructor) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? defaultConstructor : aConstructor(S);
};

export { speciesConstructor as default };
